import { tools } from './tools.js';

export const edges = {
  middleTextCoord(width, t, fontSize = 7) {
    return width / 2 - t.length * fontSize / 2;
  },
  edges(edgesJson, partX, partY, partZ, bands) {
    let result = '';
    let edgesKwargs = {
      'dominant-baseline': 'middle',
      'text-anchor': 'middle',
      edge_text: '',
      'font-size': '30px',
      style: tools.whiteTextOutline
    };

    for (let [side, edge] of Object.entries(edgesJson)) {
      if (Array.isArray(edge) || edge.db_id === undefined) {
        continue;
      }

      let band = bands.filter(b => b.id === edge.db_id);

      if (!band.length) {
        continue
      }

      band = band[0];

      let t = ['eva', 'pur', 'laz'].filter(k => edge[k]);

      if (!t.length) {
        t = '';
      } else {
        t = t[0][0];
      }

      if (edge.pre_joint) {
        t = t.toUpperCase();
      }

      t = `${band.letter} (${t}) ${band.z}`;

      if (side === 'l') {
        let x = -15;
        let y = this.middleTextCoord(partY, t, 15);
        result += tools.text(t,
          {
            x, y,
            transform: `rotate(-90) translate(-${t.length * 15} 0)`,
            ...edgesKwargs
          }
        );
      } else if (side === 't') {
        let x = this.middleTextCoord(partX, t, 15)
        let y = -15;
        result += tools.text(t, { x, y, ...edgesKwargs });
      } else if (side === 'r') {
        let x = partX + 15;
        let y = this.middleTextCoord(partY, t, 15);
        result += tools.text(
          t,
          {
            x, y,
            transform: 'rotate(90)',
            ...edgesKwargs,
          }
        );
      } else if (side === 'b') {
        let x = this.middleTextCoord(partX, t, 15);
        let y = partY + 30;
        result += tools.text(t, { x, y, ...edgesKwargs })
      }
    }

    return result;
  }
}
